import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { type ReactNode, useEffect } from 'react'
import { UAParser } from 'ua-parser-js'

import { useCart } from '@/components/cart/hooks/useCart'

interface Props {
  children: ReactNode
}

let fingerprintAgentPromise: ReturnType<typeof FingerprintJS.load> | undefined

const getFingerprintAgent = () => {
  fingerprintAgentPromise ??= FingerprintJS.load()
  return fingerprintAgentPromise
}

const getDeviceName = (parser: UAParser) => {
  const device = parser.getDevice()

  if (device.model) {
    return device.model
  }

  const browserName = parser.getBrowser().name ?? 'Unknown browser'
  const osName = parser.getOS().name ?? 'Unknown OS'

  return `${browserName} on ${osName}`
}

const AppDeviceInfoProvider = ({ children }: Props) => {
  const updateOrderMeta = useCart((state) => state.updateOrderMeta)

  useEffect(() => {
    let isActive = true

    const updateDeviceInfo = async () => {
      const parser = new UAParser()
      const os = parser.getOS()
      const fingerprintAgent = await getFingerprintAgent()
      const { visitorId } = await fingerprintAgent.get()

      if (!isActive) {
        return
      }

      updateOrderMeta({
        deviceId: visitorId,
        deviceName: getDeviceName(parser),
        deviceOs: [os.name, os.version].filter(Boolean).join(' '),
      })
    }

    void updateDeviceInfo().catch((error: unknown) => {
      console.error('Unable to collect device information', error)
    })

    return () => {
      isActive = false
    }
  }, [updateOrderMeta])

  return children
}

export default AppDeviceInfoProvider
